var map = {
	"./00_get_account_balance.json": "HY4c",
	"./02_get_asset_transfer2.json": "gp5h",
	"./07_post_capital_innerTransfer_apply.json": "KPNz",
	"./08_post_asset_transfer_new.json": "kbpg",
	"./09_get_account_transfer_support_coin.json": "IyO2",
	"./10_get_asset_transfer_record.json": "oyKG",
	"./11_get_fund_account_balance.json": "5M3S",
	"./14.get_wallet_queryInnerTransferRecords.json": "9tS2",
	"./21_get_account_allAccountBalance.json": "Exaw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kTL7";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/spot/api/account \.json$
// module id = kTL7
// module chunks = 3